import Entry from './Entry';

export default function EmailFieldControl(props) {
  return (
    <Entry type="email" {...props} />
  );
}
